import { Project } from "../../../types/Project";
import { View } from "../../../types/View";

export const getHomeView = (project: Project): View => {
	return project.views.filter(view => view.isHome)[0];
};
